// extracted by mini-css-extract-plugin
export default {"spinIcon":"CustomerAddress_spinIcon__+-Oz+","spin":"CustomerAddress_spin__PvZPl"};